var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysMapPin = function SvgSysMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sysMapPin_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#sysMapPin_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 29,
    fill: "#000",
    fillOpacity: 0.12,
    rx: 4,
    ry: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sysMapPin_svg__d",
    width: 22,
    height: 28,
    x: 1,
    y: 1,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1h22v28H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.916 20.063A9.986 9.986 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.986 9.986 0 0 0 4.084 8.063c1.882 1.418 4.535 3.655 5.145 7.257.064.381.384.677.771.677s.707-.296.771-.677c.61-3.602 3.263-5.839 5.145-7.257Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.916 20.063A9.986 9.986 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.986 9.986 0 0 0 4.084 8.063c1.882 1.418 4.535 3.655 5.145 7.257.064.381.384.677.771.677s.707-.296.771-.677c.61-3.602 3.263-5.839 5.145-7.257Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sysMapPin_svg__c)",
    d: "m17.916 20.063-.592-.806-.01.008.602.798Zm-11.832 0 .602-.798-.01-.008-.592.806Zm5.145 7.257-.986.166.986-.166Zm1.542 0 .986.166-.986-.166Zm5.737-6.451C21.23 18.869 23 15.641 23 12h-2a8.986 8.986 0 0 1-3.676 7.257l1.184 1.612ZM23 12c0-6.075-4.925-11-11-11v2a9 9 0 0 1 9 9h2ZM12 1C5.925 1 1 5.925 1 12h2a9 9 0 0 1 9-9V1ZM1 12c0 3.64 1.77 6.869 4.492 8.869l1.184-1.612A8.986 8.986 0 0 1 3 12H1Zm11.215 15.153c-.68-4.017-3.633-6.46-5.53-7.888l-1.203 1.597c1.868 1.407 4.221 3.44 4.76 6.625l1.973-.334ZM12 26.997c.069 0 .125.028.16.058.031.029.049.063.055.098l-1.972.334c.138.815.836 1.51 1.757 1.51v-2Zm-.215.156a.167.167 0 0 1 .056-.098.242.242 0 0 1 .159-.058v2c.921 0 1.62-.695 1.757-1.51l-1.972-.334Zm5.53-7.888c-1.897 1.428-4.85 3.87-5.53 7.888l1.972.334c.54-3.186 2.893-5.218 4.76-6.625l-1.203-1.597Z",
    mask: "url(#sysMapPin_svg__d)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    fill: "#000",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sysMapPin_svg__c",
    x1: 12,
    x2: 12,
    y1: 2,
    y2: 27.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sysMapPin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sysMapPin_svg__b",
    width: 12,
    height: 8,
    x: 6,
    y: 25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9868_29469",
    stdDeviation: 1
  })))));
};
export default SvgSysMapPin;